import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormInputComponent from 'webapp/components/form/input';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import type { Args } from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';
import TeamsTextComponent from 'webapp/components/teams/text';

export default class TeamsViewSectionPopupEditComponent extends PopupInnerModalComponent<PopupData.Teams.Section.Edit> {
	@service('analytics') declare analyticsService: Service.Analytics;

	@tracked title = '';
	@tracked description = '';

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		const { name, description } = this.model;
		this.title = name;
		this.description = description;
	}

	get model() {
		return this.popupData.model;
	}

	@action
	updateDescription(value: string) {
		this.description = value;
	}

	@action
	save() {
		const model = this.model,
			title = this.title,
			description = this.description;

		const action = [];
		if (model.name !== title) {
			action.push('section title');
		}
		if (model.description !== description) {
			action.push('section description');
		}

		if (!!action.length) {
			this.analyticsService.event(TrackingEvent.TEAM_PAGE_EDITED, {
				action,
			});
		}

		model.name = title;
		model.description = description;
		void model.save();
		this.close();
	}

	<template>
		<div class="title">
			<CommonUiIconComponent @name="Pencil" @size="lg" />
			Edit section
		</div>

		<div class="content">
			<div class="row input">
				<label>Section title</label>
				<div class="right">
					<FormInputComponent name="section_title" @value={{this.title}} />
				</div>
			</div>
			<div class="row input">
				<label>Description <span class="optional">(optional)</span></label>
				<div class="right">
					<TeamsTextComponent
						@placeholder="Enter your section description here..."
						@text={{this.description}}
						@onChange={{this.updateDescription}}
					/>
				</div>
			</div>
			<div class="controls2">
				<SubmitButtonComponent
					@text="Cancel"
					@theme="grey-empty"
					@noDelay={{true}}
					@onTrigger={{this.close}}
				/>
				<SubmitButtonComponent
					@text="Save"
					@onTrigger={{this.save}}
					@submitInProgress={{this.submitInProgress}}
				/>
			</div>
		</div>
	</template>
}
